export default __webpack_public_path__ + "static/media/hinh-nho-3.d6fc06db.png";